"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rendall API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetectionRowToJSON = exports.DetectionRowFromJSONTyped = exports.DetectionRowFromJSON = exports.instanceOfDetectionRow = void 0;
var runtime_1 = require("../runtime");
var DetectionSource_1 = require("./DetectionSource");
/**
 * Check if a given object implements the DetectionRow interface.
 */
function instanceOfDetectionRow(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfDetectionRow = instanceOfDetectionRow;
function DetectionRowFromJSON(json) {
    return DetectionRowFromJSONTyped(json, false);
}
exports.DetectionRowFromJSON = DetectionRowFromJSON;
function DetectionRowFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'source': !(0, runtime_1.exists)(json, 'source') ? undefined : (0, DetectionSource_1.DetectionSourceFromJSON)(json['source']),
        'title': !(0, runtime_1.exists)(json, 'title') ? undefined : json['title'],
        'technology': !(0, runtime_1.exists)(json, 'technology') ? undefined : json['technology'],
        'platforms': !(0, runtime_1.exists)(json, 'platforms') ? undefined : json['platforms'],
        'severity': !(0, runtime_1.exists)(json, 'severity') ? undefined : json['severity'],
        'cvss': !(0, runtime_1.exists)(json, 'cvss') ? undefined : json['cvss'],
        'firstPublished': !(0, runtime_1.exists)(json, 'first_published') ? undefined : (new Date(json['first_published'])),
        'lastModified': !(0, runtime_1.exists)(json, 'last_modified') ? undefined : (new Date(json['last_modified'])),
        'detectionId': !(0, runtime_1.exists)(json, 'detection_id') ? undefined : json['detection_id'],
    };
}
exports.DetectionRowFromJSONTyped = DetectionRowFromJSONTyped;
function DetectionRowToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'source': (0, DetectionSource_1.DetectionSourceToJSON)(value.source),
        'title': value.title,
        'technology': value.technology,
        'platforms': value.platforms,
        'severity': value.severity,
        'cvss': value.cvss,
        'first_published': value.firstPublished === undefined ? undefined : (value.firstPublished.toISOString()),
        'last_modified': value.lastModified === undefined ? undefined : (value.lastModified.toISOString()),
        'detection_id': value.detectionId,
    };
}
exports.DetectionRowToJSON = DetectionRowToJSON;
